// src/components/Layout.js

import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans">
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
